<template>
  <div class="user-document-page">
    <template v-if="initialized">
      <template v-if="!getConfig.hideTitle">
        <b-row class="mb-4">
          <b-col>
            <h2 class="user-document-page__title">
              {{ $t('VMX.user_documents_title') }}
            </h2>
            <p class="user-document-page__sub-title">
              {{ $t('VMX.user_documents_subheading') }}
            </p>
          </b-col>
        </b-row>
      </template>
      <!-- I am a funny comment -->
      <slot />
      <div class="user-document-page__components">
        <search-filter
          class="mb-2"
          :user-documents="userDocuments"
          :event-filter="eventFilter"
          @filter="filterValue"
          @search="search"
        />

        <template v-if="filter">
          <div class="list__results my-2">
            <b>{{ results }} {{ $t('VMX.user_documents_result_result') }}</b>
            {{ $t('VMX.user_documents_result_for') }} <b>„{{ filter }}"</b>
          </div>
        </template>

        <list
          :user-documents="data"
          :filter="filter"
          @totalRows="totalRows"
        />
      </div>
    </template>
    <template v-else>
      <div class="text-center my-2">
        <b-spinner class="align-middle" />
      </div>
    </template>
  </div>
</template>

<script>
import '../assets/scss/main.scss'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import list from '../components/list/List.vue'
import searchFilter from '../components/filter/SearchFilter.vue'

export default {
  name: 'Index',
  components: { searchFilter, list },
  props: {
    eventFilter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: null,
      initialized: false,
      filter: null,
      results: null,
    }
  },
  async mounted() {
    await this.search()
    this.initialized = true
  },
  computed: {
    ...mapGetters({
      userDocuments: 'UserDocuments/userDocuments',
      getConfig: 'ModuleConfig/moduleConfig',
    }),
  },
  methods: {
    ...mapActions({
      doSearch: 'UserDocuments/search',
    }),
    ...mapMutations({
      setUrConfig: 'ModuleConfig/setUrlConfigs',
      setToken: 'ModuleConfig/setToken',
    }),
    totalRows(params) {
      this.results = params
    },
    filterValue(params) {
      this.filter = params
    },
    async search(params) {
      let events = []
      let documentTypes = []
      if (params) {
        events = params.eventValue
        documentTypes = params.typeValue
      }
      this.data = await this.doSearch({
        events,
        documentTypes,
      })
    },
  },
}
</script>

<style scoped>

</style>
